<template>
  <div>
    <el-row class="public-profile do-not-print">
      <el-col>
        <el-row v-if="isPublic">
          <el-col>
            <el-row class="narrow">
              <el-col class="centered" :xl="5" :lg="5" :md="5" :sm="5">
                <span v-if="profile.image !== 'na' && profile.configurations">
                  <img :src="profile.image" class="image-rounded" />
                </span>
                <div v-else>
                  <span class="initials"
                    >{{ getFirstLetters(profile.fullName) }}
                  </span>
                </div>
              </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="15">
                <el-row>
                  <el-col style="text-align:center" v-if="profile.firstName">
                    <span
                      v-if="
                        profile.firstName.length > 14 ||
                          profile.surname.length > 14
                      "
                      class="cv-name email-ow"
                      style="font-size: 28px;"
                      >{{ profile.firstName.toUpperCase() }}</span
                    >
                    <span v-else class="cv-name email-ow">{{
                      profile.firstName.toUpperCase()
                    }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col style="text-align:center" v-if="profile.surname">
                    <span
                      v-if="
                        profile.firstName.length > 14 ||
                          profile.surname.length > 14
                      "
                      class="cv-name email-ow"
                      style="font-size: 28px;"
                      >{{ profile.surname.toUpperCase() }}</span
                    >
                    <span v-else class="cv-name email-ow">{{
                      profile.surname.toUpperCase()
                    }}</span>
                  </el-col>
                </el-row>
                <!-- <el-row
                  style="margin-top:20px"
                  v-if="profile.survey && profile.survey.sgaEmployeeInfo"
                >
                  <el-col
                    style="text-align:center"
                    v-if="profile.survey.sgaEmployeeInfo.employeeRoleTitle"
                  >
                    <span
                      class="role-title"
                      v-if="
                        profile.survey.sgaEmployeeInfo.employeeRoleTitle !=
                          'N/A'
                      "
                      >{{
                        profile.survey.sgaEmployeeInfo.employeeRoleTitle.toUpperCase()
                      }}</span
                    >
                  </el-col>
                </el-row> -->
              </el-col>
              <el-col
                class="centered"
                :xl="4"
                :lg="4"
                :md="4"
                :sm="4"
                v-if="profile.organisationProfile"
              >
                <span v-if="profile.organisationProfile.image !== 'na'">
                  <img
                    :src="profile.organisationProfile.image"
                    class="image-rounded"
                  />
                </span>
                <div v-else>
                  <span
                    class="initials"
                    v-if="profile.organisationProfile.initials"
                    >{{ profile.organisationProfile.initials }}
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <div v-for="(item, index) in profileSettings" :key="index">
                <el-col
                  :xl="12"
                  :lg="12"
                  :md="12"
                  :sm="12"
                  :xs="24"
                  style="padding: 20px;"
                >
                  <el-row>
                    <el-col :xl="8" :lg="10" :md="10" :sm="10" :xs="24">
                      <router-link
                        :to="'/profile/' + userid + '/' + item.id"
                        target="_blank"
                      >
                        <qrcode-vue
                          :value="rURL + '/profile/' + userid + '/' + item.id"
                          :size="size"
                          level="H"
                          style="text-align:center"
                        ></qrcode-vue>
                      </router-link>
                    </el-col>
                    <el-col :xl="16" :lg="14" :md="14" :sm="14" :xs="24">
                      <label
                        v-if="item.profileName == 'Default'"
                        style="font-weight: bold;font-size: 16px;"
                        >Default Resume</label
                      >
                      <label
                        v-else
                        style="font-weight: bold;font-size: 16px;"
                        >{{ item.profileName }}</label
                      >
                      <br />
                      <label style="font-size: 14px;">{{
                        item.profileConfiguration.personalStatement
                      }}</label
                      ><br />
                    </el-col>
                  </el-row>
                </el-col>
              </div>
            </el-row>

            <el-row
              type="flex"
              justify="center"
              style="width: 80%; margin-top: 40px; margin-bottom: 30px"
            >
              <el-col :xl="1" :lg="1" :md="1" :sm="1" :xs="2">
                <el-button class="btn-details-secondary" @click="downloadAll"
                  >Download All QR</el-button
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="not-available centered" v-else>
          <el-col :xl="15" :lg="10" :md="10" :sm="10">
            <el-row>
              <el-col style="text-align: center">
                <span>
                  <i class="fas fa-user-alt-slash fa-3x"></i>
                </span>
              </el-col>
            </el-row>
            <el-row style="text-align: center">
              <el-col>
                <span class="title">User Profile Not Available</span>
              </el-col>
            </el-row>
            <el-row style="text-align: center">
              <el-col>
                <span class="description"
                  >User has not set the profile to be available online</span
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <div hidden>
      <div
        v-for="(setting, index) in profileSettings"
        :key="index"
        :name="index"
        class="center"
      >
        <div :id="setting.id">
          <qrcode-vue
            :value="rURL + setting.id"
            :size="size"
            level="H"
            style="text-align:center"
          ></qrcode-vue>
        </div>
      </div>

      <img src="../../../assets/img/the-logo.png" id="talent-sensus-icon" />
      <img src="../../../assets/img/qr-scan-1.png" id="qr-scan-1-icon" />
      <img src="../../../assets/img/qr-scan-2.png" id="qr-scan-2-icon" />
      <img src="../../../assets/img/qr-scan-3.png" id="qr-scan-3-icon" />
      <img src="../../../assets/img/cut-here.png" id="cut-here-icon" />
      <img src="../../../assets/img/qr-card1.png" id="qr-card-icon1" />
      <img src="../../../assets/img/qr-card2.png" id="qr-card-icon2" />
      <img src="../../../assets/img/qr-board.png" id="qr-board" />
      <img src="../../../assets/img/logos/us-logo-circle.png" id="ts-logo" />
      <img
        src="../../../assets/img/logos/background-logo-circle.png"
        id="user-logo"
      />

      <input id="tsIcon" />
      <input id="qrScan1" />
      <input id="qrScan2" />
      <input id="qrScan3" />
      <input id="cutHere" />
      <input id="qrCard1" />
      <input id="qrCard2" />
      <input id="qrBoard" />
      <input id="tslogo" />
      <input id="userlogo" />
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import jsPDF from "jspdf";
import dataDelimiter from "@/utils/data.utils";

export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      profile: {},
      userid: "",
      // cvCollection: [],
      profileSettings: [],
      isPublic: true,
      size: 150,
      rURL: "",
      userInfo: {}
    };
  },
  updated() {
    this.$nextTick(() => {
      // Code that will run only after the
      // entire view has been rendered
      const usLogo = document.querySelector("#talent-sensus-icon");
      this.toDataURLCustom(usLogo.src, function(dataUrl) {
        document.getElementById("tsIcon").value = dataUrl;
      });

      const qrLogo1 = document.querySelector("#qr-scan-1-icon");
      this.toDataURLCustom(qrLogo1.src, function(dataUrl) {
        document.getElementById("qrScan1").value = dataUrl;
      });

      const qrLogo2 = document.querySelector("#qr-scan-2-icon");
      this.toDataURLCustom(qrLogo2.src, function(dataUrl) {
        document.getElementById("qrScan2").value = dataUrl;
      });

      const qrLogo3 = document.querySelector("#qr-scan-3-icon");
      this.toDataURLCustom(qrLogo3.src, function(dataUrl) {
        document.getElementById("qrScan3").value = dataUrl;
      });

      const cutLogo = document.querySelector("#cut-here-icon");
      this.toDataURLCustom(cutLogo.src, function(dataUrl) {
        document.getElementById("cutHere").value = dataUrl;
      });

      const cardLogo1 = document.querySelector("#qr-card-icon1");
      this.toDataURLCustom(cardLogo1.src, function(dataUrl) {
        document.getElementById("qrCard1").value = dataUrl;
      });

      const cardLogo2 = document.querySelector("#qr-card-icon2");
      this.toDataURLCustom(cardLogo2.src, function(dataUrl) {
        document.getElementById("qrCard2").value = dataUrl;
      });

      const cardBoard = document.querySelector("#qr-board");
      this.toDataURLCustom(cardBoard.src, function(dataUrl) {
        document.getElementById("qrBoard").value = dataUrl;
      });

      const rightLogo = document.querySelector("#ts-logo");
      this.toDataURLCustom(rightLogo.src, function(dataUrl) {
        document.getElementById("tslogo").value = dataUrl;
      });

      const leftLogo = document.querySelector("#user-logo");
      this.toDataURLCustom(leftLogo.src, function(dataUrl) {
        document.getElementById("userlogo").value = dataUrl;
      });
    });
  },
  created() {
    this.userid = this.$route.params.userid;
    this.rURL = window.location.host;
    this.$store
      .dispatch("account/getpublicprofile", this.userid)
      .then(res => {
        this.profile = res;
        debugger;
        this.isPublic = this.profile.isProfilePublic;
        this.profileSettings = res.configurations.filter(
          d => d.isActive == true
        );
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  computed: {
    userAPI() {
      if (this.$store.state.account.current_user.roles.includes("Apprentice")) {
        return "apprentice";
      } else {
        return "jobseeker";
      }
    }
  },
  methods: {
    getFirstLetters(str) {
      const firstLetters = str
        .split(" ")
        .map(word => word[0].toUpperCase())
        .join("");

      return firstLetters;
    },
    downloadAll() {
      const doc = new jsPDF();

      const favicon = document.getElementById("tsIcon").value;
      const step1 = document.getElementById("qrScan1").value;
      const step2 = document.getElementById("qrScan2").value;
      const step3 = document.getElementById("qrScan3").value;
      const cut = document.getElementById("cutHere").value;
      const card1 = document.getElementById("qrCard1").value;
      const card2 = document.getElementById("qrCard2").value;
      const board = document.getElementById("qrBoard").value;
      const rightL = document.getElementById("tslogo").value;
      const leftL = document.getElementById("userlogo").value;

      debugger;
      const pageHeight =
        doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      const pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      //doc.addImage(<image>, '<filetype>', <horizontal position>, <vertical position>, <image width>, <image height>);
      //doc.text(<string>, <horizontal position>, <vertical position>, <alignment>)

      // TalentSensus - Logo
      doc.addImage(favicon, "PNG", 125, 30, 50, 10);

      // How to Signup With No Email - Text Header
      // doc.setFont('Helvetica')
      if (doc.setFontType != undefined) doc.setFontType("bold");
      doc.setFontSize(14);
      doc.text(
        "How to View Online Profile via QRCode",
        pageWidth / 2,
        pageHeight - 245,
        "center"
      );

      // Aqua Green Line
      doc.setLineWidth(1.5);
      doc.setDrawColor(0, 200, 220);
      doc.line(100, 57, 108, 57);

      // Step 1 - Logo
      doc.addImage(step1, "PNG", 33, 65, 23, 23);

      // Step 1
      doc.setFont("Helvetica");
      if (doc.setFontType != undefined) doc.setFontType("normal");
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);

      // Line 1
      doc.text(
        60,
        75,
        "Search your smart phone app store for a QR Code Scanner and"
      );
      doc.text(60, 80, "download a scanner app");

      // Line 2
      doc.text(
        60,
        90,
        "Open your smart phone camera or Scanner app and point the"
      );
      doc.text(60, 95, "camera at the QR code");

      // Step2 - Logo
      doc.addImage(step2, "PNG", 33, 95, 23, 23);

      // Line 3
      doc.text(60, 108, "Centre the QR code while your phone scans the code");

      // Line 4
      doc.text(60, 123, "Tap the link that appears after scanning the code");

      // Step3 - Logo
      doc.addImage(step3, "PNG", 33, 125, 23, 23);

      // Line 5
      doc.text(
        60,
        135,
        "You will find yourself on My TalentSensus Online Profile Page"
      );
      doc.text(60, 140, "with the information listed below.");

      // -- Loop Start Here--
      var loopCounter = 0;
      this.profileSettings.forEach(setting => {
        let isEven = loopCounter % 2 == 0;
        let vertical = isEven ? 0 : 140;

        // Cut Here - Logo
        doc.addImage(cut, "PNG", 30, 155, 147, 5);

        doc.addImage(board, "PNG", 20, 160 - vertical, 180, 100);

        // Users resume details start's here
        // User's Image
        //doc.addImage(leftL, 'PNG', 35, 160 - vertical, 30, 30);
        doc.setFont("Helvetica");
        //doc.setFontSize(42)
        //doc.setTextColor(91, 192, 222)
        //doc.text(this.userInfo.Initials, pageWidth / 4.2 , (pageHeight - 117) - vertical, 'center')

        // TalentSensus Logo
        //doc.addImage(rightL, 'PNG', 150, 160 - vertical, 30, 30);
        doc.addImage(rightL, "PNG", 35, 170 - vertical, 30, 30);

        // User's Fullname and style
        if (doc.setFontType != undefined) doc.setFontType("bold");
        doc.setFontSize(15);
        doc.setTextColor(35, 39, 42);
        doc.text(
          this.profile.fullName,
          pageWidth / 2.6,
          pageHeight - 115 - vertical,
          "left"
        );

        // User's Role and style
        if (doc.setFontType != undefined) doc.setFontType("bold");
        doc.setFontSize(10);
        
        const roleTitle = this.profile.survey.sgaEmployeeInfo.employeeRoleTitle || "";

        var roles = roleTitle.split(dataDelimiter);

        var role1 = "";
        var topResumeTitle = 0;
        for (let index = 0; index < roles.length; index++) {
          if (index <= 1) {
            role1 += roles[index] + ",";
            if (index == roles.length - 1 || index == 1) {
              var formattedRole = role1
                .trim()
                .substring(0, role1.trim().length - 1);
              doc.text(
                formattedRole,
                pageWidth / 2.6,
                pageHeight - 110 - vertical,
                "left"
              );
              role1 = "";
              topResumeTitle = pageHeight - 110 - vertical;
            }
          } else if (index <= 3) {
            role1 += roles[index] + ",";
            if (index == roles.length - 1 || index == 3) {
              var formattedRole = role1
                .trim()
                .substring(0, role1.trim().length - 1);
              doc.text(
                formattedRole,
                pageWidth / 2.6,
                pageHeight - 106 - vertical,
                "left"
              );
              role1 = "";
              topResumeTitle = pageHeight - 106 - vertical;
            }
          } else {
            role1 += roles[index] + ",";
            if (index == roles.length - 1) {
              var formattedRole = role1
                .trim()
                .substring(0, role1.trim().length - 1);
              doc.text(
                formattedRole,
                pageWidth / 2.6,
                pageHeight - 102 - vertical,
                "left"
              );
              role1 = "";
              topResumeTitle = pageHeight - 102 - vertical;
            }
          }
        }

        // User's Settings name and style
        if (doc.setFontType != undefined) doc.setFontType("normal");
        doc.setFontSize(9);
        var title =
          setting.profileName == "Default"
            ? "Default Resume"
            : setting.profileName;
        doc.text(
          "Resume : " + title,
          pageWidth / 2.6,
          topResumeTitle + 5,
          "left"
        );

        // Personal Information & Core Strenght Title
        if (doc.setFontType != undefined) doc.setFontType("bold");
        doc.setFontSize(12);
        doc.text(
          "Personal",
          pageWidth / 4.5,
          pageHeight - 89 - vertical,
          "center"
        );
        doc.text(
          "Information",
          pageWidth / 4.5,
          pageHeight - 85 - vertical,
          "center"
        );
        doc.text(
          "Core Strength",
          pageWidth / 2.4,
          pageHeight - 89 - vertical,
          "center"
        );
        doc.text(
          "Information",
          pageWidth / 2.4,
          pageHeight - 85 - vertical,
          "center"
        );

        if (doc.setFontType != undefined) doc.setFontType("normal");
        doc.setFontSize(9);
        const itemHeight = 4;
        // Personal items
        var personal = setting.profileConfiguration.personalInformation;
        var personalInfo = Object.entries(personal);
        var personalCtr = 0;
        for (let i = 0; i < personalInfo.length; i++) {
          if (i == 10) {
            const education = Object.entries(personalInfo[i][1]);
            if (education === undefined) {
              continue;
            }
            for (let j = 0; j < education.length; j++) {
              var res = education[j].includes(true);
              if (res) {
                personalCtr += 1;
                doc.text(
                  personalInfo[i][0].trim(),
                  pageWidth / 5.3,
                  pageHeight - vertical - (83 - personalCtr * itemHeight),
                  "left"
                );
                break;
              }
            }
          } else {
            var res = personalInfo[i].includes(true);
            if (res) {
              personalCtr += 1;
              if (i == 1) {
                doc.text(
                  "ZipCode",
                  pageWidth / 5.3,
                  pageHeight - vertical - (83 - personalCtr * itemHeight),
                  "left"
                );
              } else {
                doc.text(
                  personalInfo[i][0],
                  pageWidth / 5.3,
                  pageHeight - vertical - (83 - personalCtr * itemHeight),
                  "left"
                );
              }
            }
          }
        }
        // Core Strenght items
        var coreStrength = setting.profileConfiguration.coreStrengthInformation;
        var coreInfo = Object.entries(coreStrength);
        var coreCtr = 0;
        var trues = 0;
        for (let i = 0; i < coreInfo.length; i++) {
          var res = coreInfo[i].includes(true);
          if (res) {
            coreCtr += 1;
            if (i == 0) {
              doc.text(
                this.$i18n.messages[localStorage.getItem("locale")]
                  .uorganization + " Name",
                pageWidth / 2.8,
                pageHeight - vertical - (83 - coreCtr * itemHeight),
                "left"
              );
              trues += 1;
            } else {
              if (trues < 6) {
                doc.text(
                  coreInfo[i][0],
                  pageWidth / 2.8,
                  pageHeight - vertical - (83 - coreCtr * itemHeight),
                  "left"
                );
                trues += 1;
              } else {
                doc.text(
                  coreInfo[i][0],
                  pageWidth / 2,
                  pageHeight - vertical - (83 - (coreCtr - 6) * itemHeight),
                  "left"
                );
                trues += 1;
              }
            }
          }
        }

        doc.text(
          "Please scan my QR to view My Resume",
          pageWidth / 1.3,
          pageHeight - 89 - vertical,
          "center"
        );

        var canvas = document
          .getElementById(setting.id)
          .querySelector("canvas");
        var dataURL = canvas.toDataURL();
        doc.addImage(dataURL, "PNG", 145, 210 - vertical, 30, 30);

        // Date generated
        var today = new Date();
        var month = today.getMonth() + 1;
        var day = today.getDate();
        var year = today.getFullYear();

        doc.setFont("courier");
        if (doc.setFontType != undefined) doc.setFontType("normal");
        doc.setFontSize(10);
        doc.setTextColor(133, 133, 133);
        doc.text(
          day + "-" + month + "-" + year.toString().substring(2),
          pageWidth / 2,
          pageHeight - 15,
          "center"
        );

        // Contact us
        doc.text(
          "support@talentsensus.com",
          pageWidth / 2,
          pageHeight - 10,
          "center"
        );
        loopCounter += 1;

        if (loopCounter % 2 != 0 && loopCounter < this.profileSettings.length)
          doc.addPage();
      });
      // -- Loop End --

      doc.save("qrcode-all.pdf");
    },
    toDataURLCustom(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    }
  }
};
</script>
